import { Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { userNotificationsStore } from 'stores/global/RootStore';

import Item from './Item';

const List: React.FC = () => {
  const { list } = userNotificationsStore;

  return (
    <Stack gap="lg">
      {list.map((item) => (
        <Item key={item.id} data={item} />
      ))}
    </Stack>
  );
};

export default observer(List);
